import React, { useState, useEffect } from 'react';
import { Modal } from 'antd';
import { useTheme } from 'styled-components';

import { MySubtitleH4 } from '../../styled/publicTag';
import { message } from 'antd';

import {  ExclamationCircleOutlined, CloseCircleOutlined, CheckCircleFilled } from '@ant-design/icons';
import { getAllMold, deleteMold, getMold } from '../../services/api';

import ModalContainer from './ModalContainer'

import Title from '../../components/Custom/Title';
import Wrapper from '../../components/Custom/Wrapper';
import CustomTable from '../../components/antdCustom/CustomTable';
import CustomModal from '../../components/antdCustom/CustomModal';

import {
  IconTrash,
  IconPen
} from '../../components/Icon'


message.config({
  duration: 1.5
})

const Mould = () => {

  const innerWidth = window.innerWidth;

  const theme = useTheme();

  const [s_tableData, set_s_tableData] = useState([]);
  const [s_showModal, set_s_showModal] = useState(false);  // 是否開啟 dialog
  const [s_MouldData, set_s_MouldData] = useState({});     // 要編輯的模具資料

  const [s_searchValue, set_s_searchValue] = useState('');    // 要搜尋的文字

  const [pageInfo, setPageInfo] = useState({
    currentPage: 0,
    pageItemNumber: 10,
    totalItems: 0,
    pageSize: 10
  });

  // 新增模具資料
  const createMould = () => {
    set_s_showModal(true);
  }

  // 搜尋模具資料
  const onSearch = (value, event) => {
    const call_getMold = async (value) => {
      
      if(value === '') return;
      
      const res = await getMold(value);
      
      if(res.status) {
        set_s_tableData(res.data);
        message.success(res.msg);
      } else {
        message.error(res.msg);
      }

    }
    call_getMold(value);
  }

  // 編輯模具資料
  const editMould = rowData => {
    set_s_showModal(true);
    set_s_MouldData(rowData);
  }

   // 刪除模具資料
   const removeMould = rowData => {
    Modal.confirm({
      title: '模具資料刪除確認',
      icon: <ExclamationCircleOutlined style={{color: 'red'}} />,
      content: '請先確認要刪除的模具資料無誤，再進行刪除',
      okText: '確定',
      onOk: async () => {
        console.log('要刪除的資料 = ', rowData)
        const res = await deleteMold(rowData);
        res.status ? message.success(res.msg) : message.error(res.msg);
        //刪除後要更新資料
        call_getAllMould();
      },
      cancelText: '取消',
    });
  }

  // 取得所有模具資料
  const call_getAllMould = async () => {
    try {
      const res = s_searchValue === '' ? await getAllMold() : await getMold(s_searchValue);
      
      if(res.data) {
        console.log('全部模具資料 = ', res.data);
        const tmpData = res.data.map((item, index) => {
          return {
            ...item,
            key: index
          }
        });
        set_s_tableData(tmpData)
      }
      
    } catch (e) {
      console.log('---------- api getAllStaffPerm error ----------');
      console.log(e)
    }
  }
  
  const tableColumns = [
    {
      title: '模具編號',
      dataIndex: 'moldID',
      key: 'moldID',
      align: 'center',
      width: innerWidth <= 1440 ? `${200}px` : `${200}px`
    },
    {
      title: '料號',
      dataIndex: 'PN',
      key: 'PN',
      align: 'center',
      width: innerWidth <= 1440 ? `${150}px` : `${200}px`,
    },
    {
      title: '品名',
      dataIndex: 'pdtNM',
      key: 'pdtNM',
      align: 'center',
      // width: innerWidth <= 1440 ? `${150}px` : `${200}px`,
    },
    {
      title: '使用工站',
      dataIndex: 'wsNM',
      key: 'wsNM',
      align: 'center',
      width: innerWidth <= 1440 ? `${100}px` : `${150}px`
    },
    {
      title: '穴數',
      dataIndex: 'moldcavity',
      key: 'moldcavity',
      align: 'center',
      width: innerWidth <= 1440 ? `${100}px` : `${100}px`
    },
    {
      title: '共模設定',
      dataIndex: 'moldtype',
      key: 'moldtype',
      align: 'center',
      width: innerWidth <= 1440 ? `${100}px` : `${120}px`,
      render: (text, rowData, index) => {
        const key = rowData.moldtype;
        const moldtypeMap = {
          1: '單料模具',
          2: '雙料模具',
          3: '三料模具',
          4: '四料模具'
        }
        return {
          children: (
            <div>
             {moldtypeMap[key]}
            </div>
          )
        };
      }
    },
    {
      title: '上模時間(分)',
      dataIndex: 'setuptime',
      key: 'setuptime',
      align: 'center',
      width: innerWidth <= 1440 ? `${150}px` : `${150}px`
    },
    {
      title: '模保頻率設定',
      dataIndex: 'setmrrfreq',
      key: 'setmrrfreq',
      align: 'center',
      width: innerWidth <= 1440 ? `${150}px` : `${150}px`,
      render: (text, rowData, index) => {
        const key = rowData.setmrrfreq;
        return {
          props: {
            style: { backgroundColor: '#eeffee' }
          },
          children: (
            <div className="checkIcon">
             {key === 'Y' ? <CheckCircleFilled className='successIcon' /> : <CloseCircleOutlined style={{color: 'gray'}} />}
            </div>
          )
        };
      }
    },
    {
      title: '模保次數',
      dataIndex: 'mrrfreq',
      key: 'mrrferq',
      align: 'center',
      width: innerWidth <= 1440 ? `${100}px` : `${100}px`,
      render: (text, rowData, index) => {

        return {
          props: {
            style: { backgroundColor: '#eeffee' }
          },
          children: (
            <div style={{display: 'flex',justifyContent: 'center'}}>
              {text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            </div>
          )
        }
      }
    },
    {
      title: '模保週期設定',
      dataIndex: 'setmrrcycle',
      key: 'setmrrcycle',
      align: 'center',
      width: innerWidth <= 1440 ? `${150}px` : `${150}px`,
      render: (text, rowData, index) => {
        const key = rowData.setmrrcycle;
        return {
          props: {
            style: { backgroundColor: '#f8f8ff' }
          },
          children: (
            <div className="checkIcon">
             {key === 'Y' ? <CheckCircleFilled className='successIcon' /> : <CloseCircleOutlined style={{color: 'gray'}} />}
            </div>
          )
        };
      }
    },
    {
      title: '模保週期',
      dataIndex: 'mrrcycleUnit',
      key: 'mrrcycleUnit',
      align: 'center',
      width: innerWidth <= 1440 ? `${100}px` : `${100}px`,
      render: (text, rowData, index) => {
        const key = rowData.setmrrcycle;
        return {
          props: {
            style: { backgroundColor: '#f8f8ff' }
          },
          children: (
            <div>
             {key === 'Y' ? `${rowData.mrrcycleUnit}` : '無'}
            </div>
          )
        };
      }
    },
    {
      title: '模具保養週期',
      dataIndex: 'mrrcycle',
      key: 'mrrcycle',
      align: 'center',
      width: innerWidth <= 1440 ? `${150}px` : `${150}px`,
      render: (text, rowData, index) => {
        const key = rowData.mrrcycle;
        return {
          props: {
            style: { backgroundColor: '#f8f8ff' }
          },
          children: (
            <>
             {key}
            </>
          )
        };
      }
    },
    {
      title: '操作',
      dataIndex: 'render',
      key: 'render',
      align: 'center',
      width: innerWidth <= 1440 ? `${100}px` : `${100}px`,
      render: (text, rowData, index) => (
        <div style={{display: 'flex',justifyContent: 'center'}}>
          <div style={{display: 'flex'}}>
            <IconPen className='icon' onClick={() => editMould(rowData)} />
            <IconTrash className='icon' onClick={() => removeMould(rowData)} />
          </div>
        </div>
      )
    },
  ]

  // 取得所有模具資料
  useEffect(() => { 
    call_getAllMould();
  }, []);

  const handleChange = async value => {
    console.log(value)
    set_s_searchValue(value)
    if(value === '') {
      try {
        const res = await getAllMold();
        
        if(res.data) {
          console.log('全部模具資料 = ', res.data);
          const tmpData = res.data.map((item, index) => {
            return {
              ...item,
              key: index
            }
          });
          set_s_tableData(tmpData)
        }
        
      } catch (e) {
        console.log('---------- api getAllStaffPerm error ----------');
        console.log(e)
      }
    }
  }
  
  return (
    <>
      <Title 
        title='生產模具管理'
        placeholder='請輸入欲查詢模具資料'
        onSearch={onSearch}
        handleChange={handleChange}
        handleClick={createMould}
      />
      <CustomTable 
        scroll={{x: 'max-content', y: window.innerHeight - 60 - 45 - 220 }}
        columns={tableColumns}
        dataSource={s_tableData.map((item, index) => {
          return {
            key: index,
            ...item
          }
        })}
        pagination={{
          defaultCurrent: 1,
          total: pageInfo.totalItems,
          // current: abcBoardConfig.page,
          showSizeChanger: true,
          pageSize: pageInfo.pageSize,
          pageSizeOptions: ["10", "20", "30"],
          onChange: (current, size) => {
            setPageInfo({
              ...pageInfo,
              pageSize: size
            })
          },
          showTotal: (total, range) => (
            <MySubtitleH4>
              共 {total} 項 ， 正在顯示第{range[0]}到{range[1]}項
            </MySubtitleH4>
          ),
        }}
      />
      {s_showModal ? (
        <CustomModal 
          width='60%' 
          title={Object.keys(s_MouldData).length > 0 ? "修改生產模具管理資料" : "新建生產模具管理資料"} 
          visible={s_showModal} 
          maskClosable={false}
          destroyOnClose
          footer={null}
          forceRender
          getContainer={false}
          onCancel={() => set_s_showModal(false)}
          afterClose={() => {
            set_s_MouldData({});
            call_getAllMould();
          }}
        >
          <ModalContainer set_s_showModal={set_s_showModal} s_MouldData={s_MouldData} set_s_MouldData={set_s_MouldData} call_getAllMould={call_getAllMould} />
        </CustomModal>
      ) : null}
      
    </>
  )
};

export default Mould;